var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":_vm.id,"modal-class":"guide-modal","size":"lg","hide-footer":"","hide-header":"","centered":""}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }